// 6 is default for commonality of stablecoins
export function removeExcessDecimals(float, decimals = 6) {
  const factor = Math.pow(10, decimals);
  return Math.floor(float * factor) / factor;
};
